import type { AiInterviewInvite } from "@/store/modules/recruiter_ai_interviews/interfaces";

const isPlaceholderJobLabel = (value: string): boolean =>
  /^job\s*#\s*\d+$/i.test(value.trim());

/**
 * Human-readable job line for interview invite lists: real title/role first, then cached fetch by job_id.
 */
export function jobLabelForAiInterviewInvite(
  invite: AiInterviewInvite | Record<string, unknown> | null | undefined,
  jobTitleById: Record<string, string>
): string {
  if (!invite) return "-";
  const inv = invite as AiInterviewInvite & { job_title?: string | null };
  const jobTitle = String(inv.job_title || "").trim();
  if (jobTitle && !isPlaceholderJobLabel(jobTitle)) return jobTitle;
  const jobRole = String(inv.job_role || "").trim();
  if (jobRole && !isPlaceholderJobLabel(jobRole)) return jobRole;
  const jobId = inv.job_id;
  if (jobId == null || !Number.isFinite(Number(jobId)) || Number(jobId) === 0) return "-";
  const resolved = String(jobTitleById[String(jobId)] || "").trim();
  if (resolved) return resolved;
  return "-";
}
